"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _ = require("../..");
var _jsxRuntime = require("react/jsx-runtime");
var avatarSize = {
  s: _globalTokens.globalSizing["600"],
  m: _globalTokens.globalSizing["800"],
  xl: _globalTokens.globalSizing["2400"]
};
var borderRadius = {
  s: _globalTokens.globalBorder.radius["2"],
  m: _globalTokens.globalBorder.radius["2"],
  xl: _globalTokens.globalBorder.radius["3"]
};
var AvatarText = function AvatarText(_ref) {
  var size = _ref.size,
    children = _ref.children;
  switch (size) {
    case "xl":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Heading, {
        size: '1',
        color: "white",
        children: children
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Text, {
        size: size === "s" ? "2" : "1",
        color: "white",
        children: children
      });
  }
};
var Image = _styledComponents.default.img.withConfig({
  displayName: "Avatar__Image",
  componentId: "sc-1jsjbm2-0"
})(["height:", ";width:", ";border-radius:", ";flex-shrink:0;"], function (_ref2) {
  var size = _ref2.size;
  return avatarSize[size];
}, function (_ref3) {
  var size = _ref3.size;
  return avatarSize[size];
}, function (_ref4) {
  var size = _ref4.size;
  return borderRadius[size];
});
var AvatarWrapper = _styledComponents.default.div.withConfig({
  displayName: "Avatar__AvatarWrapper",
  componentId: "sc-1jsjbm2-1"
})(["display:flex;align-items:center;justify-content:center;flex-shrink:0;height:", ";width:", ";background-color:", ";border-radius:", ";"], function (_ref5) {
  var size = _ref5.size;
  return avatarSize[size];
}, function (_ref6) {
  var size = _ref6.size;
  return avatarSize[size];
}, _globalTokens.globalColor.brand.primary, function (_ref7) {
  var size = _ref7.size;
  return borderRadius[size];
});
var getInitials = function getInitials(name) {
  if (!name || name.length === 0) {
    return "";
  }
  var splitName = name
  // eslint-disable-next-line
  .replace(/[\x00-\x1F\x7F-\x9F]/g, " ") // matches all UNICODE control characters
  .split(" ").filter(function (token) {
    return token !== "";
  });
  if (splitName.length === 0) {
    return "";
  }
  return "".concat(splitName[0][0]).concat(splitName.length >= 2 ? splitName[splitName.length - 1][0] : "");
};
var Avatar = function Avatar(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: props.src ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Image, _objectSpread({
      crossOrigin: "use-credentials",
      alt: ""
    }, props)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarWrapper, _objectSpread({}, props, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarText, {
        size: props.size,
        children: getInitials(props.name)
      })
    }))
  });
};
var _default = exports.default = Avatar;